import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from './store/store'
import authMiddleware from './middleware/authMiddleware'
import './registerServiceWorker'
import { MessageBox } from 'element-ui';
import i18n from './i18n'

import initRealTimeSdk from '@/plugins/initRealTimeSdk';
import PortalVue from 'portal-vue'
import dashboardPlugin from './plugins/dashboardPlugin'
import storageLoggerPlugin from './plugins/storageLoggerPlugin'
import '@/assets/css/icon-vc.css'

Vue.config.productionTip = false

Vue.use(PortalVue)
Vue.use(VueRouter)
Vue.use(dashboardPlugin)
Vue.use(storageLoggerPlugin)

Vue.prototype.$confirm = MessageBox.confirm;

Vue.prototype.$isDev = process.env.VUE_APP_API_URL.includes('dev')

authMiddleware(router, store)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
})
    .$mount('#app')

initRealTimeSdk()
    .then(() => {
        console.log('Real time SDK Initialized')
    })
//
